import { component } from '../../framework/component.decorator';
import { events } from '../../events';
import { CookieConsentType } from '../../models/cookie-consent-type.enum';
import { button } from '../../templating/button.element';
import { hasGivenConsentFor } from '../../utils/has-given-consent-for.fn';
import { optIn } from '../../utils/opt-in.fn';
import { optOut } from '../../utils/opt-out.fn';
import { BaseComponent } from '../../framework/base.component';
import styles from './opt-out.component.scss';

@component({
  selector: 'app-opt-out',
  styles,
})
export class OptOutComponent extends BaseComponent<OptOutComponent> {
  constructor() {
    super(OptOutComponent);
  }

  async createInitialComponent(): Promise<HTMLElement | HTMLElement[]> {
    const textContent = this.getButtonText();

    return button({
      textContent,
      onCreate: (element) => {
        element.addEventListener('click', () => this.onClick(element));
      },
    });
  }

  private async onClick(button: HTMLButtonElement) {
    const onConsentSet = events.onceAsync('consent-set');

    if (hasGivenConsentFor(CookieConsentType.Statistics)) {
      events.emit('remove-consent', { consent: CookieConsentType.Statistics });
    } else {
      events.emit('add-consent', { consent: CookieConsentType.Statistics });
    }

    await onConsentSet;

    button.textContent = this.getButtonText();
  }

  private getButtonText() {
    return `Opt ${
      hasGivenConsentFor(CookieConsentType.Statistics) ? 'out' : 'in'
    } of Google tracking`;
  }
}
